import { FC } from 'react';
import { BsQuestionCircle } from 'react-icons/bs';
import {
  Box,
  Field,
  FieldLabelProps,
  Icon,
  useSlotRecipe,
} from '@chakra-ui/react';

import { Tooltip } from '../../lib/chakraUi/components';

export type FormLabelProps = FieldLabelProps & {
  helpText?: string;
  htmlFor?: string;
  required?: boolean;
  optionalText?: string;
  readOnly?: boolean;
  readOnlyText?: string;
  size?: 'lg' | 'md';
  hideValidationLabel?: boolean;
};

// @TODO Change this to use useMultiStyleConfig()

export const FormLabel: FC<FormLabelProps> = ({
  children,
  helpText,
  htmlFor,
  required = false,
  optionalText = '',
  readOnly,
  readOnlyText,
  hideValidationLabel,
  size,
  ...props
}) => {
  const recipe = useSlotRecipe({ key: 'field' });
  const { tooltipIcon, requiredIndicator, label, root } = recipe();

  return (
    <Field.Label
      color={root.color}
      css={label}
      {...(htmlFor && { htmlFor, id: `${htmlFor}-label` })}
      {...props}
    >
      {children}

      {hideValidationLabel ? null : (
        <Box as="span" css={requiredIndicator}>
          {!required && <>&nbsp;{optionalText}</>}
          {readOnly ? <>&nbsp;{readOnlyText || '(view only)'}</> : ''}
        </Box>
      )}

      {helpText && (
        <Tooltip content={helpText}>
          <Box as="span" css={tooltipIcon} ml={2}>
            <Icon as={BsQuestionCircle} boxSize={4} />
          </Box>
        </Tooltip>
      )}
    </Field.Label>
  );
};
